export default __webpack_public_path__ + "static/media/CNo.75-2.3955d84d.jpg";